import { randomUUID } from '@chillibean/component-library';

export const emptyStudyEventDefinitions = (num, displayName) => {
  return Array(num)
    .fill({
      displayName: displayName,
      id: 0,
      identifier: 'STUDY_EVENT_DEFINITION',
    })
    .map((studyEventDefinition) => {
      return { ...studyEventDefinition, id: `template-${randomUUID()}` };
    });
};

export const emptyStudyProcedureDefinitions = (num, displayName) => {
  return Array(num)
    .fill({
      displayName: displayName,
      id: 0,
      identifier: 'STUDY_PROCEDURE_DEFINITION',
    })
    .map((studyProcedureDefinition) => {
      return { ...studyProcedureDefinition, id: `template-${randomUUID()}` };
    });
};

export const filterStudyEventDefinitionByStudyArm = ({ currentFilteredStudyArm, studyArms, studyEventDefinitions }) => {
  switch (currentFilteredStudyArm.id) {
    case -1:
      return studyEventDefinitions.filter((studyEventDefinition) => studyEventDefinition?.studyArm === null);
    case 0:
      return studyEventDefinitions;
    default: {
      const studyArm = studyArms.find((sa) => sa.id === currentFilteredStudyArm.id);
      return studyEventDefinitions.filter(
        (studyEventDefinition) =>
          studyEventDefinition?.studyArm === null || studyEventDefinition?.studyArm?.id === studyArm?.id,
      );
    }
  }
};
